/** 引入 drag-move 交互 */
import '../../../interactions/drag-move';
/** 引入 drill-down 交互 */
import '../../../interactions/drill-down';
//# sourceMappingURL=index.js.map